import React from "react";
import ContentBox from "../ContentBox";
import RankEntry from "../RankEntry";
import "./index.css";

// ========================================
// RANK CATEGORY COMPONENT - FOR RANK GROUPS
// ========================================
// This component displays a category of ranks (like "Regimental Command" or "Warrant Officers")
// It uses ContentBox for the header and maps over ranks to display RankEntry components
//
// PROPS YOU CAN EDIT:
// - title: The category title (e.g., "Regimental Command", "Warrant Officers")
// - description: The description text for the entire category
// - ranks: Array of rank objects with icon, title, tag, and description
//
// TO ADD A NEW RANK CATEGORY:
// 1. Go to src/pages/Ranks/index.js
// 2. Find the rankCategories array
// 3. Add a new category object with title, description, and ranks array
// 4. Each rank in the ranks array should have: icon, title, tag (optional), description
//
// TO CHANGE CATEGORY STYLING:
// 1. Go to src/components/RankCategory/index.css
// 2. Edit the .rank-description or .rank-entries classes
// 3. Modify colors, fonts, spacing, etc.

const RankCategory = ({ title, description, ranks }) => {
  return (
    <ContentBox header={title}>
      {/* CATEGORY DESCRIPTION - Change the description prop to update this text */}
      <div className="rank-description">{description}</div>

      {/* RANKS LIST - Automatically displays all ranks in the ranks array */}
      <div className="rank-entries">
        {ranks.map((rank, index) => (
          <RankEntry
            key={index}
            icon={rank.icon}
            title={rank.title}
            tag={rank.tag}
            description={rank.description}
          />
        ))}
      </div>
    </ContentBox>
  );
};

export default RankCategory;
